const AddButtonV1 = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
      <path
        d='M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z'
        fill='#8B5CF6'
      />
      <path
        d='M12.7895 8.28947H9.71053V5.21053C9.71053 5.02208 9.63567 4.84136 9.50242 4.70811C9.36917 4.57486 9.18844 4.5 9 4.5C8.81156 4.5 8.63083 4.57486 8.49758 4.70811C8.36433 4.84136 8.28947 5.02208 8.28947 5.21053V8.28947H5.21053C5.02208 8.28947 4.84136 8.36433 4.70811 8.49758C4.57486 8.63083 4.5 8.81156 4.5 9C4.5 9.18844 4.57486 9.36917 4.70811 9.50242C4.84136 9.63567 5.02208 9.71053 5.21053 9.71053H8.28947V12.7895C8.28947 12.9779 8.36433 13.1586 8.49758 13.2919C8.63083 13.4251 8.81156 13.5 9 13.5C9.18844 13.5 9.36917 13.4251 9.50242 13.2919C9.63567 13.1586 9.71053 12.9779 9.71053 12.7895V9.71053H12.7895C12.9779 9.71053 13.1586 9.63567 13.2919 9.50242C13.4251 9.36917 13.5 9.18844 13.5 9C13.5 8.81156 13.4251 8.63083 13.2919 8.49758C13.1586 8.36433 12.9779 8.28947 12.7895 8.28947Z'
        fill='white'
      />
    </svg>
  );
};

export default AddButtonV1;
